// eslint-disable-next-line no-unused-vars
import AbstractServiceNavigationBehaviour from './abstract-service-navigation-behaviour';
import { bool2str, KeyCode } from '../../util';

export default class ServiceNavigation {

    static get SERVICE_NAVIGATION_CLASS_EXPANDED() {
        return 'services-panel--expanded';
    }

    constructor() {
        /**
         * @type {AbstractServiceNavigationBehaviour}
         * @private
         */
        this._behaviour = null;
        /**
         * @type {Element|null}
         * @private
         */
        this._element = null;
        /**
         * @type {Element|null}
         * @private
         */
        this._toggleButton = null;
        this._isOpen = false;
        this.toggleExtended = this.toggleExtended.bind(this);
        this._addEventListeners = this._addEventListeners.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onOpen = this._onOpen.bind(this);
        this._onFocusOut = this._onFocusOut.bind(this);
        this._onFocusIn = this._onFocusIn.bind(this);
        this._onTitleClick = this._onTitleClick.bind(this);

        this._addEventListeners();
        // document.body.style.height = '100vh';
        // document.body.style.overflowY = 'auto';
    }

    /**
     * @param {AbstractServiceNavigationBehaviour} behaviour
     */
    set behaviour(behaviour) {
        if (this._behaviour !== null) {
            this._behaviour.destroy();
        }
        this._behaviour = behaviour;
        this._behaviour.init();
    }

    /**
     * @param {Element} el
     */
    set element(el) {
        this._element = el;
        if (this._toggleButton !== null) {
            this._toggleButton.removeEventListener('click', this._onOpen);
        }
        this._toggleButton = el.querySelector('[data-action="toggleServiceNavigation"]');
        if (this._toggleButton === null) {
            throw new ReferenceError('An element with \'[data - action= "toggleServiceNavigation"]\'  is expected!');
        }
        this._toggleButton.addEventListener('click', this._onOpen);
        const title = this._element.querySelector('.services-panel__title');
        if (this._element !== null) {
            this._element.removeEventListener('focusout', this._onFocusOut);
            this._element.removeEventListener('focusin', this._onFocusIn);
        }
        if (title !== null) {
            title.removeEventListener('click', this._onTitleClick);
        }
        this._element.addEventListener('focusout', this._onFocusOut);
        this._element.addEventListener('focusin', this._onFocusIn);
        title.addEventListener('click', this._onTitleClick);
    }

    /**
     * @param {boolean} shouldDisplay
     */
    toggleExtended(shouldDisplay) {
        if (this._element === null)
            return;
        this._element.classList.toggle(ServiceNavigation.SERVICE_NAVIGATION_CLASS_EXPANDED, shouldDisplay);
        this._element.dataset.expanded = bool2str(shouldDisplay);
    }

    /**
     * @param {boolean} isOpen
     */
    set open(isOpen) {
        if (this._element === null)
            return;
        this._isOpen = isOpen;
        this._element.setAttribute('aria-expanded', bool2str(isOpen));
        this._toggleButton.querySelector('.services-panel__item__label--desktop').innerText = this._toggleButton.dataset['label' + (isOpen ? 'Close' : 'Open')];
        this._toggleButton.querySelector('.services-panel__item__label--mobile').innerText = this._toggleButton.dataset['label' + (isOpen ? 'Close' : 'Open')];
        const x = document.body.scrollLeft + document.documentElement.scrollLeft;
        const y = document.body.scrollTop + document.documentElement.scrollTop;

        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.body.scrollLeft = x;
            document.body.scrollTop = y;
        } else {
            document.body.style.overflow = '';
            window.scrollTo(x, y);
        }
    }

    get open() {
        return this._isOpen;
    }

    _onTitleClick() {
        if (this.open)
            return;
        this.open = true;
    }

    _onOpen() {
        this.open = !this.open;
    }

    _onKeyDown(e) {
        if (this.open && e.keyCode === KeyCode.ESCAPE)
            this.open = false;
    }

    /**
     * @param {FocusEvent} e
     * @private
     */
    _onFocusOut(e) {
        if (document.activeElement === null || !this._element.contains(e.relatedTarget)) {
            this.open = false;
        }
    }

    /**
     * @param {FocusEvent} e
     * @private
     */
    _onFocusIn(e) {
        if (!e.target || !e.target.parentElement || !e.target.parentElement.classList.contains('services-panel__item'))
            return;
        const item = e.target.parentElement;
        const rect = item.getBoundingClientRect();
        const elementInViewPort = rect.top < window.innerHeight;
        if (e.target.hidden || !elementInViewPort) {
            this.open = true;
        }
    }

    _addEventListeners() {
        document.addEventListener('keydown', this._onKeyDown);
    }
}
